import { composeReceipt } from './composeReceipt';

/**
 * A sample bill, for previews. Real enough to show what a design does — two
 * items, some tax, a customer, a delivery address — without needing a sale.
 */
export const SAMPLE_BILL = {
  id: '1042',
  locationId: '',
  branchName: 'Main Branch',
  date: '2026-09-01',
  createdAt: '2026-09-01T18:45:12.000Z',
  customer: 'Ravi Kumar',
  phone: '98400 12345',
  method: 'cash',
  orderType: 'in-shop',
  deliveryAddress: '12 Anna Salai, Mount Road, Chennai 600002',
  lines: [
    { name: 'Soap', label: '100ml', qty: 2, price: 30, lineTotal: 60 },
    { name: 'Shampoo', label: '200ml', qty: 1, price: 85, lineTotal: 85 },
  ],
  subtotal: 145,
  totalCgst: 13.05,
  totalSgst: 13.05,
  totalIgst: 0,
  total: 171.1,
};

/**
 * A plain-text rendering of a receipt, for previews and thumbnails.
 *
 * The layout comes from `composeReceipt`, the same function the thermal printer
 * and the browser bill use, so a preview cannot show something the paper will
 * not. It used to be a second copy of the layout rules, and drifted: the
 * printer's item columns overflowed 58mm paper while the preview's did not, and
 * the printer dropped zero tax lines the preview showed.
 */
export const renderReceiptPreview = (org, cfg, bill = SAMPLE_BILL) => {
  const { blocks, width } = composeReceipt(org, bill, cfg);

  const centre = (t) => ' '.repeat(Math.max(0, Math.floor((width - t.length) / 2))) + t;
  const right = (t) => t.padStart(width);

  return blocks.map((b) => {
    if (b.kind === 'blank') return '';
    if (b.kind === 'divider') return '-'.repeat(b.width || width);
    // A monospace preview cannot draw a scannable code, and a fake one would be
    // a lie about what prints. It says what the printer will encode instead.
    if (b.kind === 'qr') {
      const box = ['+---------+', '|  [ QR ] |', '+---------+'].map(centre);
      if (b.caption) box.push(centre(b.caption.slice(0, width)));
      return box.join('\n');
    }
    const text = String(b.text || '');
    if (b.align === 'center') return centre(text.slice(0, width));
    if (b.align === 'right') return right(text.slice(0, width));
    return text;
  }).join('\n');
};
